import React, { useState, useEffect } from "react";
import styles from "./AddGrievances.module.css";
import { grievanceService } from "../../services/grievanceService";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

export default function AddGrievances({ onSubmitted, onCancel }) {
    const [issueTypes, setIssueTypes] = useState([]);

    useEffect(() => {
        const fetchIssueTypes = async () => {
            try {
                const response = await grievanceService.getIssueTypes();
                if (response) {
                    setIssueTypes(response);
                }
            } catch (error) {
                console.error("Error fetching issue types:", error);
                toast.error("Failed to load issue types");
            }
        };
        fetchIssueTypes();
    }, []);

    const [formData, setFormData] = useState({
        complaint_type: "",
        issue_type: "",
        subject: "",
        message_text: "",
        grievancesAttachment: null,
    });

    // ---------------- VALIDATION LOGIC ADDED HERE ----------------
    const handleChange = (e) => {
        const { name, files, value } = e.target;

        if (!files) {
            setFormData((prev) => ({ ...prev, [name]: value }));
            return;
        }

        if (!files) return;

        const file = files[0];
        if (!file) return;

        const MAX_SIZE = 5 * 1024 * 1024; // 5MB

        // ---- GET EXTENSION ----
        const ext = file.name.split('.').pop().toLowerCase();

        const allowedExtensions = [
            "jpg", "jpeg", "png", "gif", "webp",
            "pdf",
            "txt",
            "doc", "docx",
            "zip", "rar"
        ];

        if (file.size > MAX_SIZE) {
            toast.error("❌ File size must be under 5MB");
            e.target.value = null;
            return;
        }

        if (!allowedExtensions.includes(ext)) {
            toast.error("❌ Unsupported file type");
            e.target.value = null;
            return;
        }

        // VALID FILE
        setFormData((prev) => ({ ...prev, [name]: file }));
    };

    // -------------------------------------------------------------------

    const handleClearAttachment = () => {
        setFormData((prev) => ({ ...prev, grievancesAttachment: null }));
        document.getElementById("attachmentInput").value = "";
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const form = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (value) form.append(key, value);
            });

            await grievanceService.createGrievance(form);
            toast.success("Complaint submitted successfully!");
            
            if (onSubmitted) {
                setTimeout(onSubmitted, 1200);
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to submit complaint!");
        }
    };

    return (
        <div>
            <ToastContainer position="top-center" autoClose={2000} />
            <form className={styles.form} onSubmit={handleSubmit}>

                    {/* Row 1 */}
                    <div className={styles.row}>
                        <div className={styles.inputGroup}>
                            <label>Complaint Type <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="text"
                                name="complaint_type"
                                value={formData.complaint_type}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className={styles.inputGroup}>
                            <label>Issue Type <span style={{ color: 'red' }}>*</span></label>
                            <select
                                name="issue_type"
                                value={formData.issue_type}
                                onChange={handleChange}
                                required
                            >
                                <option value="">Select</option>
                                {issueTypes.map((type) => (
                                    <option key={type} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className={styles.inputGroup}>
                            <label>Subject <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="text"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Message */}
                    <div className={styles.inputGroupFull}>
                        <label>Message <span style={{ color: 'red' }}>*</span></label>
                        <textarea
                            name="message_text"
                            value={formData.message_text}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Attachment */}
                    <div className={styles.row}>
                        <div className={styles.inputGroup}>

                            {/* UPDATED LABEL */}
                            <label>
                                Attachment
                                <span style={{ fontSize: "12px", color: "#FF0000" }}>
                                    {" "} (Max 5MB • Image, PDF, Txt, Word, Zip, Rar)
                                </span>
                            </label>

                            <input
                                id="attachmentInput"
                                type="file"
                                name="grievancesAttachment"
                                onChange={handleChange}
                                accept="
                                    image/*,
                                    application/pdf,
                                    text/plain,
                                    application/msword,
                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                    .zip,
                                    .rar
                                "

                            />

                            {formData.grievancesAttachment && (
                                <div className={styles.attachmentPreview}>
                                    <span>{formData.grievancesAttachment.name}</span>
                                    <button type="button" onClick={handleClearAttachment}>
                                        Clear
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className={styles.buttonGroup}>
                        <button type="submit" className={styles.submitBtn}>
                            Submit
                        </button>
                        <button
                            type="button"
                            className={styles.backBtn}
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                    </div>

                </form>
        </div>
    );
}
